<a class="wrapper-image" [link]="product()" uiProductLink [enableProductClickTracking]="true" [position]="position()">
  @if (standardImage(); as image) {
    <img [alt]="product().details.name" [src]="image.large">
  } @else {
    <img [alt]="product().details.name" src="./assets/img/package.svg">
  }
</a>

<div class="wrapper-content">
  <div class="wrapper-labels">
    @if (showBundleLabel()) {
      <ui-product-bundle-label></ui-product-bundle-label>
    }
    <ui-product-bundle-valid-to-label
      [showActionLabel]="false"
      [validTo]="product().bundle?.validTo"
    ></ui-product-bundle-valid-to-label>
  </div>
  <span class="bundle-name">{{ product().details.name }}</span>
  <p class="bundle-description">{{ product().details.description }}</p>

  <div class="wrapper-actions">
    <a
      class="bundle-link"
      matButton="outlined"
      [link]="product()"
      uiProductLink
      [position]="position()"
    >
      <ui-icon faName="arrow-right" faStyle="light"></ui-icon>
      &nbsp;
      Paket zusammenstellen
    </a>
  </div>
</div>
